var BASE_URL = "https://core.teadrop.us/";
// const BASE_URL = "http://192.168.1.8:8000/"
var GRAPH_BASE = "https://graph.microsoft.com/";
export { BASE_URL, GRAPH_BASE };
